import type { SearchEntityType, SearchResponse } from '@peles/shared';
import type {
  SearchRequest,
  SearchResponse as GlobalSearchResponse,
  SearchTransport,
  SearchTypeInfo,
} from '@speles7172/search-client/core';
import { apiClient } from './client';

/** The pickers' lookup (`SearchableSelect`): one kind, by name. */
export async function searchEntities(
  type: SearchEntityType,
  query: string,
  limit = 20,
): Promise<SearchResponse> {
  const { data } = await apiClient.get<SearchResponse>('/search', {
    params: { type, q: query, limit },
  });
  return data;
}

/**
 * The global search over `GET /search` (no `type`): the kinds this person may
 * search, and the grouped answer for a text.
 *
 * ⚠️ **Module-level, so its identity never changes.** `useGlobalSearch` keys
 * its effects on the transport; one built inside a component would be a new
 * transport every render, and every render would search again.
 */
export const globalSearchTransport: SearchTransport = {
  async types(): Promise<SearchTypeInfo[]> {
    const { data } = await apiClient.get<{ types: SearchTypeInfo[] }>('/search');
    return data.types;
  },
  async search(request: SearchRequest, signal?: AbortSignal): Promise<GlobalSearchResponse> {
    const { data } = await apiClient.get<GlobalSearchResponse>('/search', {
      params: {
        q: request.q,
        ...(request.types?.length ? { types: request.types.join(',') } : {}),
        ...(request.from ? { from: request.from } : {}),
        ...(request.to ? { to: request.to } : {}),
        ...(request.limit ? { limit: request.limit } : {}),
      },
      signal,
    });
    return data;
  },
};
